import s from './style.css';

const SVGs = () => (
	<div
		style={{
			display: 'none'
		}}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 8 8"
		>
			<path
				id="sparkle"
				d="M4 8c0-2.211-1.789-4-4-4 2.211 0 4-1.789 4-4 0 2.211 1.789 4 4 4-2.211 0-4 1.789-4 4"
				fill="#D4F4E8"
				fill-rule="evenodd"
			/>
		</svg>

		<svg
			className={s.heart}
			width="70"
			height="70"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill-rule="evenodd" id="heart">
				<path
					d="M69.6667 35.8333c0 18.6858-15.1478 33.8334-33.8334 33.8334C17.1475 69.6667 2 54.519 2 35.8333 2 17.1478 17.1475 2 35.8333 2 54.519 2 69.6667 17.1478 69.6667 35.8333"
					fill="currentColor"
				/>
				<path
					d="M67.6667 33.8333c0 18.6856-15.1476 33.8334-33.8334 33.8334C15.1478 67.6667 0 52.5189 0 33.8333 0 15.1475 15.1478 0 33.8333 0c18.6858 0 33.8334 15.1475 33.8334 33.8333"
					fill="inherit"
				/>
				<path
					d="M58.6387 17.331c-6.155-6.7016-16.577-7.1446-23.2783-.9897a.7498.7498 0 0 1-.0148.0135c-.7707.7099-1.9404.7099-2.7112 0a.7501.7501 0 0 1-.0147-.0135c-6.7014-6.155-17.1234-5.7119-23.2786.9897-6.1546 6.7014-5.7116 17.1236.9897 23.2783l21.6917 21.0498c1.096 1.0634 2.839 1.0634 3.935 0L57.649 40.6093c6.7016-6.1547 7.1446-16.577.9897-23.2783z"
					stroke="#E74347"
					stroke-linejoin="round"
				/>
			</g>
		</svg>
	</div>
);

export default SVGs;



// WEBPACK FOOTER //
// ./components/SVGs/index.js